"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconPinterest = void 0;
var React = __importStar(require("react"));
var IconPinterest = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M12.0015,3 C7.0305,3 3,7.029 3,12 C3,15.6585 5.187,18.81 8.3235,20.217 C8.2785,19.5765 8.271,18.7125 8.454,17.9445 C8.616,17.259 9.54,13.3455 9.54,13.3455 C9.54,13.3455 9.27,12.8085 9.27,12.0105 C9.27,10.7595 9.9945,9.828 10.8975,9.828 C11.664,9.828 12.036,10.404 12.036,11.094 C12.036,11.8665 11.544,13.02 11.2905,14.0895 C11.0805,14.985 11.742,15.7125 12.624,15.7125 C14.223,15.7125 15.3,13.659 15.3,11.226 C15.3,9.378 14.055,7.992 11.787,7.992 C9.2265,7.992 7.6305,9.9015 7.6305,12.0315 C7.6305,12.7665 7.848,13.2855 8.187,13.6875 C8.3415,13.8705 8.3655,13.9485 8.3055,14.1585 C8.265,14.313 8.172,14.6865 8.1345,14.838 C8.0775,15.051 7.9065,15.129 7.713,15.048 C6.5325,14.5665 5.985,13.2765 5.985,11.8245 C5.985,9.426 8.007,6.5535 12.0165,6.5535 C15.24,6.5535 17.3565,8.886 17.3565,11.388 C17.3565,14.697 15.519,17.1705 12.804,17.1705 C11.8935,17.1705 11.034,16.6785 10.743,16.1205 C10.743,16.1205 10.254,18.0645 10.149,18.441 C9.9345,19.218 9.4725,19.998 9.114,20.529 C10.023,20.835 10.989,21 11.9985,21 C16.971,21 21,16.971 21,12 C21,7.029 16.9725,3 12.0015,3" }))); };
exports.IconPinterest = IconPinterest;
exports.IconPinterest.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconPinterest;
